import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import axios from "axios";
import React, { forwardRef, useMemo } from "react";
/*lineType Components*/
import "./QrGenerator.css";


const DeleteGameLines = forwardRef((props) => {

    const [rotation, setRotation] = React.useState("");
    const [game, setGame] = React.useState();
    const userInfo = useMemo(
        () => JSON.parse(localStorage.getItem("userInfo")),
        []
    );

    const options = {
        page: 1, // which page you want to show as default
        sizePerPageList: [
            {
                text: "15",
                value: 15,
            },
            {
                text: "50",
                value: 50,
            },
            {
                text: "500",
                value: 500,
            },
            {
                text: "1000",
                value: 1000,
            },
        ], // you can change the dropdown list for size per page
        sizePerPage: 10, // which size per page you want to locate as default
        pageStartIndex: 1, // where to start counting the pages
        paginationSize: 3, // the pagination bar size.
        prePage: "Prev", // Previous page button text
        nextPage: "Next", // Next page button text
        firstPage: "First", // First page button text
        lastPage: "Last", // Last page button text
        paginationShowsTotal: true, // Accept bool or function
        paginationPosition: "bottom", // default is bottom, top and both is all available
        afterDeleteRow: onAfterDeleteRow, // A hook for after droping rows.
        handleConfirmDeleteRow: customConfirm,
        onRowClick: selectedValues,
    };

    function customConfirm(next, dropRowKeys) {
        const dropRowKeysStr = dropRowKeys.join(",");
        if (
            window.confirm(
                `(It's a custom confirm)Are you sure you want to delete the game: ${dropRowKeysStr}?`
            )
        ) {
            // If the confirmation is true, call the function that
            // continues the deletion of the record.
            next();
        }
    }

    function selectedValues(row) {
        setGame(row.IdGame);
    }

    function onAfterDeleteRow(rowKeys) {
        console.log('game====>', rowKeys)
        const url =
            process.env.REACT_APP_API2_URL +
            "/Game/SystemChangeLogDeleteLog?idGame=" +
            rowKeys;
        axios
            .get(url)
            .then((response) => {
                console.log('HasPrefix response ===>', response)
                if (response.data >= 0) {
                    toast.success("Log deleted");
                } else {
                    toast.error("Error");
                }
            })
            .catch((error) => {
                console.error("Error fetching agent prefix:", error);
                setHasPrefix(false);
            });
    }

    const selectRowProp = {
        mode: "radio",

        clickToSelect: false, // click to select, default is false
        clickToExpand: false, // click to expand row, default is false
    };


    const GetGameByRotation = () => {
        // Change for server api address
        const url =
            process.env.REACT_APP_API2_URL +
            "/Game/GetGameByRotation?rotation=" +
            rotation;
        axios
            .get(url)
            .then((response) => {
                setGame(response.data)
            })
            .catch((error) => {
                setHasPrefix(false);
            });
    };

    // Manejar el cambio en el campo de texto del prefijo
    const handleRotationChange = (event) => {
        setRotation(event.target.value);
    };

    const handleGetGameInfo = () => {
        GetGameByRotation();
    };


    return (
        <React.Fragment>
            <div className="sticky top-0 flex-grow-0">
                {/* Other components or content */}
            </div>
            <div className="flex-1 pl-4 h-max">
                <Paper>
                    <div class="row">
                        <div class="column">
                            <TextField
                                size="small"
                                type="text"
                                label="Rotation Number"
                                onChange={handleRotationChange}
                                multiline={false}
                                variant="outlined"
                            />
                        </div>
                        <div class="column" style={{ paddingLeft: '10px' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleGetGameInfo}
                            >
                                Get Game Info
                            </Button>
                        </div>
                    </div>
                    <br></br>
                    {game && (
                        <div>
                            <BootstrapTable
                                pagination={true}
                                options={options}
                                selectRow={selectRowProp}
                                insertRow={false}
                                version="4"
                                data={game}
                                deleteRow={true}
                                hover
                            >
                                <TableHeaderColumn
                                    dataField="IdGame"
                                    hiddenOnInsert
                                    hidden
                                    isKey={true}
                                    autoValue={true}
                                >
                                    ID
                                </TableHeaderColumn>

                                <TableHeaderColumn
                                    dataField="IdSport"
                                    filter={{ type: "TextFilter", delay: 1000 }}
                                >
                                    Sport
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataField="VisitorTeam"
                                    filter={{ type: "TextFilter", delay: 1000 }}
                                >
                                    Visitor
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataField="HomeTeam"
                                    filter={{ type: "TextFilter", delay: 1000 }}
                                >
                                    Home
                                </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    )}
                </Paper>
            </div>
        </React.Fragment>
    );
});

export default DeleteGameLines;
